<template>
    <div class="tools">
      <!-- Header -->
      <div class="bg-secondary text-neutral-content flex items-center justify-start p-2 px-4 mt-[-5px] rounded-b-lg min-h-[100px]">
        <div class="text-xl">Automations
          <p class="text-sm text-gray-300 !mt-0">Create and manage your automations here</p>
        </div>

      </div>
  
      <!-- Template Cards -->
      <div class="card card-border bg-base-100 w-full">
        <div class="card-body flex !flex-row items-center justify-between !p-2 gap-4">
          <!-- <h2 class="card-title">Schedule Posts</h2> -->
          <p class="text-center">Mass Generate and schedule posts or complicated workflows with a few clicks. <span class="badge badge-xs bg-green-200 border-0 ml-2">Coming Soon..</span></p>
        <DotLottieVue style="height: 200px; width: 200px;" autoplay loop :src="`${pluginUrl}/assets/bot.lottie`" />
          
        </div>
      </div>
  
      <!-- Edit Template Modal -->
      <TemplateModal 
        ref="editModal" 
        :editTitle="editTitle" 
        :editContent="editContent" 
        @update:editTitle="editTitle = $event"
        @update:editContent="editContent = $event"
        @save="saveTemplate"
      />
  
      
    </div>
  </template>
  
  <script>
  import TemplateModal from './templateModal.vue';
  import { DotLottieVue } from '@lottiefiles/dotlottie-vue'

  export default {
    name: 'AdminAutomations',
    components: {
      TemplateModal,
      DotLottieVue
    },
    data() {
      return {
        pluginUrl: window.smartpress_vars.pluginUrl || '',
        editTitle: 'Edit Template Title',
        editContent: 'Template Content hello {{name}}',
      }
    },
    methods: {
      editModal() {
        this.$refs.editModal.showModal();
      },
      newTemplate() {
        this.editTitle = 'New Template Title';
        this.editContent = 'Write an article about {{name}}';
        this.editModal();
      },
      saveTemplate() {
        // Here you can handle saving the template
        console.log('Template saved with title:', this.editTitle);
        console.log('And content:', this.editContent);
        // Implement your save logic here
      }
    }
  }
  </script> 